<template>
  <div>
    <div class="searchType">
      <!-- <span :class="['typeLabel',{mobileFontSize:$isMobile}]">搜索类型:</span>
      <el-select v-model="type" placeholder="请选择">
        <el-option v-for="(item,i) in types" :key="i" :label="item" :value="item">
        </el-option>
      </el-select>-->
      <el-input size="mini" v-model="searchKey" placeholder="请输入中文名或化学文摘号" clearable>
        <i class="iconfont iconsousuo" type="primary" @click="findAllTouchLimit" slot="suffix"></i>
      </el-input>&nbsp;&nbsp;
      <el-button size="mini" plain type="primary" @click="review">预览并导出</el-button>
    </div>
    <div>
      <el-radio-group v-model="initial" size="mini">
        <el-radio-button label="全部"></el-radio-button>
        <el-radio-button
          v-for="(item,i) in pinyin"
          :disabled="initialArr.indexOf(item)!=-1?false:true"
          :label="item"
          :key="i"
        >{{item}}</el-radio-button>
      </el-radio-group>
    </div>
    <el-table
      size="mini"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      v-if="!$isMobile"
      :data="touchLimits"
      style="width: 100%"
    >
      <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
      <el-table-column prop="showName" align="center" label="中文名"></el-table-column>
      <el-table-column label="别名" align="center" prop="chineseName">
        <template slot-scope="scope">
          <span v-html="scope.row.chineseName?scope.row.chineseName.join('、'):'-'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="englishName" align="center" label="英文名"></el-table-column>
      <el-table-column prop="casNum" align="center" :label="chemistryLabel" width="100%">
        <template slot-scope="scope">
          <p>{{scope.row.casNum?scope.row.casNum:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="PC-TWA" align="center">
        <el-table-column label="总尘" align="center" width="50%">
          <template slot-scope="scope">
            <p>{{scope.row.PC_TWA?scope.row.PC_TWA:'-'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="呼尘" align="center" width="50%">
          <template slot-scope="scope">
            <p>{{scope.row.respirableDust_TWA ?scope.row.respirableDust_TWA:'-'}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="healthEffect" label="临界不良健康效应" align="center"></el-table-column>
      <el-table-column prop="samplingMedium" label="采样介质" align="center"></el-table-column>
      <el-table-column label="采样方式" align="center">
        <el-table-column label="定点" align="center">
          <template slot-scope="scope">
            <p>{{scope.row.fixedPointDetection?`${scope.row.fixedPointDetection.flow}${scope.row.fixedPointDetection.instrument}${scope.row.fixedPointDetection.samplingTime}`:'-'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="个体" align="center">
          <template slot-scope="scope">
            <p>{{scope.row.individualDetection ?`${scope.row.individualDetection.flow}${scope.row.individualDetection.instrument}${scope.row.individualDetection.samplingTime}`:'-'}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column prop="standard" label="采样依据" align="center" width="180%"></el-table-column>
      <el-table-column prop="note" label="备注" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.note?scope.row.note:'-'}}</p>
        </template>
      </el-table-column>
    </el-table>

    <!-- 移动端 -->
    <el-table
      size="mini"
      class="mobileTable"
      :row-key="getRowKey"
      @selection-change="handleSelectionChange"
      v-show="$isMobile"
      :data="touchLimits"
      style="width: 100%"
    >
      <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-form label-position="left" class="demo-table-expand">
            <el-form-item label="采样介质">
              <span>{{scope.row.samplingMedium || '-'}}</span>
            </el-form-item>
            <el-form-item label="定点">
              <p>{{scope.row.fixedPointDetection?`${scope.row.fixedPointDetection.flow}${scope.row.fixedPointDetection.instrument}${scope.row.fixedPointDetection.samplingTime|| '-'}`:'-'}}</p>
            </el-form-item>
            <el-form-item label="个体">
              <p>{{scope.row.individualDetection ?`${scope.row.individualDetection.flow}${scope.row.individualDetection.instrument}${scope.row.individualDetection.samplingTime|| '-'}`:'-'}}</p>
            </el-form-item>
            <el-form-item label="采样依据">{{scope.row.standard || '-'}}</el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="中文名" prop="showName"></el-table-column>
      <el-table-column label="别名" prop="chineseName">
        <template slot-scope="scope">
          <span v-html="scope.row.chineseName?scope.row.chineseName.join('、'):'-'"></span>
        </template>
      </el-table-column>
      <el-table-column label="化学文摘号" prop="casNum">
        <template slot-scope="scope">
          <p>{{scope.row.casNum?scope.row.casNum:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="PC-TWA" align="center">
        <el-table-column label="总尘" align="center" width="50%">
          <template slot-scope="scope">
            <p>{{scope.row.PC_TWA?scope.row.PC_TWA:'-'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="呼尘" align="center" width="50%">
          <template slot-scope="scope">
            <p>{{scope.row.respirableDust_TWA ?scope.row.respirableDust_TWA:'-'}}</p>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="临界不良效应">
        <template slot-scope="scope">
          <p style="margin-left: 10px">{{scope.row.healthEffect?scope.row.healthEffect:'-'}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.note?scope.row.note:'-'}}</p>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="10"
        :total="totalLength"
        :current-page="currentPage"
        @current-change="currentchange"
        ref="pagination"
      ></el-pagination>
    </div>
    <!-- 预览导出对话框 -->
    <el-dialog :width="$isMobile?'80%':'50%'" title="预览并导出excel" :visible.sync="dialogFormVisible">
      <el-tag
        @close="closeTag(i)"
        closable
        v-for="(item,i) in multipleSelection"
        :key="i"
      >{{item.chineseName}}</el-tag>
      <div slot="footer" class="dialog-footer">
        <el-button :size="$isMobile?'mini':'medium'" @click="dialogFormVisible = false">取 消</el-button>
        <json-excel
          :footer="footer"
          type="xls"
          class="json2excel"
          :fields="json_fields"
          :data="multipleSelection"
          title="工作场所粉尘有害因素职业接触限值"
          name="工作场所粉尘有害因素职业接触限值"
        >
          <el-button
            :size="$isMobile?'mini':'medium'"
            type="primary"
            @click="dialogFormVisible = false"
          >确 定</el-button>
        </json-excel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
export default {
  data() {
    return {
      footer:
        "表中列出的各种粉尘（石棉纤维尘除外），凡游离 SiO2 等于或高于10%者，均按矽尘职业接触限值对待。指游离SiO2低于10%，不含石棉和有毒物质，而未制定职业接触限值的粉尘。",
      //获取row的key值
      getRowKey(row) {
        return row._id;
      },
      multipleSelection: [],
      dialogFormVisible: false,
      json_fields: {
        序号: "index",
        粉尘因素中文名称: "chineseName",
        总尘: "PCTWA.AllDust",
        呼尘: "PCTWA.respirableDust",
        "PC-STEL": "OELs.PC_STEL",
        备注: "note"
      },
      chemistryLabel: `化学文摘号
        CAS号`,
      pinyin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "W",
        "X",
        "Y",
        "Z"
      ],
      displayInitalArr: [],
      initial: "全部", //首字母
      initialArr: [], //所有数据的首字母集合
      types: ["中文名", "化学文摘号"],
      type: "中文名",
      totalLength: 0, //数据总长度
      currentPage: 1,
      touchLimits: [],
      searchKey: ""
    };
  },
  watch: {
    initial(newval) {
      //监听选择的首字母
      this.currentPage = 1;
      this.findAllTouchLimit();
    },
    searchKey(newval) {
      //监听搜索框文本
      if (!newval) {
        this.findAllTouchLimit();
      }
    }
  },
  created() {
    //按回车键触发
    document.onkeydown = e => {
      let key = window.event.keyCode;
      if (key === 13) {
        this.findAllTouchLimit();
      }
    };
    this.findInitialList();
    this.findAllTouchLimit();
  },
  props: {
    // touchLimits:{
    //   type:Array
    // }
  },
  components: {
    JsonExcel
  },
  methods: {
    review() {
      this.dialogFormVisible = true;
      if (this.multipleSelection.length === 0) {
        this.dialogFormVisible = false;
        this.message({
          message: "您暂未选择",
          type: "warning"
        });
      }
    },
    closeTag(i) {
      this.multipleSelection.splice(i, 1);
    },
    //复选框
    handleSelectionChange(val) {
      val.map((item, i) => {
        item.index = i + 1;
      });
      this.multipleSelection = val;
    },
    currentchange() {
      this.currentPage = this.$refs.pagination.internalCurrentPage;
      this.findAllTouchLimit();
    },
    //获取开头首字母集合
    async findInitialList() {
      let res = await this.$axios.get(
        this.$serviceAPI.findDustTouchLimitInitials
      );
      this.initialArr = res.data.data.map(item => item.initial);
    },
    //查询
    async findAllTouchLimit() {
      // let params = {
      //   pageNum: this.currentPage
      // }
      if (this.searchKey != "") {
        this.currentPage = 1;
      }
      // if (this.type === '中文名') {
      //   params = {
      //     casNum: '',
      //     chineseName: this.searchKey,
      //     pageNum: this.currentPage,
      //     initial: this.initial
      //   }
      // } else {
      //   params = {
      //     casNum: this.searchKey,
      //     chineseName: '',
      //     pageNum: this.currentPage,
      //     initial: this.initial
      //   }
      // }
      let initial = this.initial;
      if (initial === "全部") {
        initial = "";
      }
      let params = {
        pageNum: this.currentPage,
        initial,
        searchkey: this.searchKey
      };
      let res = await this.$axios.post(
        this.$serviceAPI.findDustTouchLimit,
        params
      );
      // orderByFirstPin(res.data.data.data, 'chineseName')
      this.touchLimits = res.data.data.data;
      this.totalLength = res.data.data.totalLength;
    }
  }
};
</script>

<style scoped="scoped">
.el-table {
  -moz-box-shadow: 0px 1px 7px #cfcfcf;
  -webkit-box-shadow: 0px 1px 7px #cfcfcf;
  box-shadow: 0px 1px 7px #cfcfcf;
}
</style>



// WEBPACK FOOTER //
// src/components/subPage/dustTouchLimit.vue